import {reduce} from './array';
import {isArray, isFunction} from './is';
import {owns} from './object';

const
    update = (object, ...keys) => {
        const last = keys.length - 1;

        if (last < 0) {
            return (
                value => (
                    isFunction(value) ?
                        value(object) :
                        value));
        } else {
            const
                updated = isArray(object) ? [...object] : {...object},
                level = (
                    reduce(
                        keys,
                        (level, key, i) => (
                            i < last ?
                                level[key] = (
                                    owns(level, key) ?
                                        (isArray(level[key]) ?
                                            [...level[key]] :
                                            {...level[key]}) :
                                        {}) :
                                level),
                        updated));

            return (
                value => {
                    level[keys[last]] = (
                        isFunction(value) ?
                            value(level[keys[last]]) :
                            value);
                    return updated;
                });
        }
    };

export {
    update
};
